module.exports = __webpack_public_path__ + "img/qq-icon.8c6f6bd9.svg";